// if (!customElements.get('plug-slider')) {
//     customElements.define('plug-slider', class Plugslider extends HTMLElement {
//       constructor() {
//         super();
//         let flickity_settings = ["freeScroll", "wrapAround", "fade","adaptiveHeight", "prevNextButtons","pageDots"];
//         this.slider = this.querySelector('[plug-slider]');
//         this.settings = this.slider.getAttribute('flickity_settings').replaceAll('\'', '\"');
//         if (this.settings != undefined) {
//           this.settings = JSON.parse(this.settings);
//         } else {
//           this.settings = {};
//           flickity_settings.forEach((settings) => {
//             let value = this.getAttribute(`flickity-${settings}`);
//             if (value != undefined) {
//               this.settings[settings] = value;
//             }
//           });
//         }
  
//         // custom-elements
//         this.slide = this.getAttribute('plug-slide');
//         this.arrow = this.querySelector('[plug-arrows]');
//         this.thumbnail = this.querySelector('[plug-thumbnail]');
  
//         if (this.slide !=  undefined) {
//           this.settings["plug-slide"] = this.slide;
//         }
//         this.init();
//       }
  
//       init() {
//         var flkty = new Flickity( this.slider,this.settings);
//         if (this.arrow != undefined) {
//           this.initArrows(flkty);
//         }
//         if (this.thumbnail != undefined) {
//           this.initThumbnails();
//         }
//       }
  
//       initArrows(flkty) {
//         let next = this.arrow.querySelector('[plug-next]');
//         let prev = this.arrow.querySelector('[plug-prev]');
//         let wrapped = Object.is(this.slider.getAttribute('flickity-wrapAround'), undefined) ? false : true; 
//         next.addEventListener('click',  ()=> {
//           flkty.next(wrapped)
//         });
//         prev.addEventListener('click',  ()=> {
//           flkty.previous(wrapped)
//         });
//       }
  
//       initThumbnails() {
//         let settings = this.settings;
//         settings["asNavFor"] = this.slider;
//         var flkty = new Flickity( this.thumbnail, settings);
//       }
//     })
// }

if (!customElements.get('collection-tab')) {
    customElements.define('collection-tab', class collectionTab extends HTMLElement {
        constructor() {
            super();
            this.alltab = Array.from(document.querySelectorAll('collection-tab'));
            this.target = document.querySelector(`#${this.getAttribute('target')}`);
            this.addEventListener('click', this.clickEvent.bind(this));
            this.similar_tab = Array.from(document.querySelectorAll(`[target="${this.getAttribute('target')}"]`)).filter(child => child !== this);
            this.alltab = this.alltab.filter(child => child !== this);
            this.alltab = this.alltab.filter(child => child !== this.similar_tab[0]);
            if (this.classList.contains('tabs--mobile')) {
                this.setHeight();
                window.addEventListener("resize", this.setHeight.bind(this));
            }
            

        }
        clickEvent(event) {
            this.setState();
        }

        setState() {
            let getState = this.getAttribute('aria-selected');
            if (getState === "false") {
                this.alltab.forEach((sibling_tab)=> {
                    if (sibling_tab != this) {
                        sibling_tab.setAttribute('aria-selected', false);
                        let target = document.querySelector(`#${sibling_tab.getAttribute('target')}`);
                        target.setAttribute('aria-hidden', true);

                        let sibling_slides = target.querySelectorAll('.collection-tabs__slide');
                        sibling_slides.forEach((slide) => {
                            slide.setAttribute('aria-hidden', true);
                            slide.setAttribute('tabindex', '-1');
                        });
                    }
                });
                this.similar_tab.forEach((tab)=>{
                    tab.setAttribute('aria-selected', true);
                })
                this.setAttribute('aria-selected', true);
                this.target.setAttribute('aria-hidden', false);
                let target_slides = this.target.querySelectorAll('.collection-tabs__slide');
                target_slides.forEach((slide) => {
                    slide.setAttribute('aria-hidden', false);
                    slide.setAttribute('tabindex', '0');
                });
            } else {
                console.log(window.innerWidth)
                if (window.innerWidth < 1000) {
                    this.setAttribute('aria-selected', false);
                    this.target.setAttribute('aria-hidden', true);
                    let target_slides = this.target.querySelectorAll('.collection-tabs__slide');
                    target_slides.forEach((slide) => {
                        slide.setAttribute('aria-hidden', false);
                        slide.setAttribute('tabindex', '0');
                    });
                }
            }
        }

        setHeight() {
            console.log('Resize')
          setTimeout(()=> {
            let height = this.target.querySelector('plug-slider').offsetHeight;
            this.target.style.maxHeight = height + 'px';  
          }, 100)

        }
    })
}

